module.exports = __webpack_public_path__ + "img/inst-modal-8.8082f541.png";